// ! fayoztepa buddist majmuasi
import fayoz1 from "../../photos/uzb_term_fayoz1.webp";
import fayoz2 from "../../photos/uzb_term_fayoz2.webp";
import fayoz3 from "../../photos/uzb_term_fayoz3.webp";

// ! qadimiy termiz (eski shahar)
import eskisha1 from "../../photos/uzb_term_eskisha1.webp";
import eskisha2 from "../../photos/uzb_term_eskisha2.webp";
import eskisha3 from "../../photos/uzb_term_eskisha3.webp";

// ! al-hakim at-termiziy maqbarasi
import hakim1 from "../../photos/uzb_term_hakim1.webp";
import hakim2 from "../../photos/uzb_term_hakim2.webp";
import hakim3 from "../../photos/uzb_term_hakim3.webp";

// ! sulton saodat majmuasi
import saodat1 from "../../photos/uzb_term_saodat1.webp";
import saodat2 from "../../photos/uzb_term_saodat2.webp";
import saodat3 from "../../photos/uzb_term_saodat3.webp";

// ! zurmala minorasi
import zurmala1 from "../../photos/uzb_term_zurmala1.webp";
import zurmala2 from "../../photos/uzb_term_zurmala2.webp";
import zurmala3 from "../../photos/uzb_term_zurmala3.webp";

// ! kampirtepa qadimiy istehkomi
import kampirtepa1 from "../../photos/uzb_term_kampirtepa1.webp";
import kampirtepa2 from "../../photos/uzb_term_kampirtepa2.webp";
import kampirtepa3 from "../../photos/uzb_term_kampirtepa3.webp";

const termiz = {
    uz: {
        key: "termiz",
        title: "Termiz — sivilizatsiyalar tutashgan qadimiy shahar",

        intro: `
Termiz — Surxondaryo viloyatida, Amudaryo bo‘yida joylashgan, 2500 yildan ortiq tarixga ega qadimiy shahar.
Bu yer buddizm, zardushtiylik va islom madaniyatlari kesishgan noyob hudud bo‘lib, Buyuk Ipak yo‘lining muhim bekati bo‘lgan.
  `,

        history: `
Termiz — Markaziy Osiyoning eng qadimiy shaharlaridan biri bo‘lib, uning tarixi Aleksandr Makedonskiy davriga borib taqaladi. Ayrim manbalarga ko‘ra, shahar aynan yunon-baqtriya davrida "Aleksandriya Oksiana" nomi bilan asos solingan.

Kushon imperiyasi davrida (I–IV asrlar) Termiz muhim savdo va diniy markazga aylangan — bu davrda shaharda buddizm keng tarqalgan bo‘lib, atrofda ko‘plab monastir va ibodatxonalar qurilgan.

Amudaryoning qulay kechuv nuqtasida joylashgani sababli Termiz Buyuk Ipak yo‘lining eng muhim bekatlaridan biriga aylangan — bu yerda Hindiston, Xitoy, Eron va O‘rta yer dengizi mamlakatlari savdogarlari uchrashgan.

IX–XII asrlarda Termiz islom ilm-fani markazlaridan biriga aylandi, bu yerda buyuk olim va faylasuf Abu Abdulloh Muhammad al-Hakim at-Termiziy yashab ijod etgan.

1220-yilda Chingizxon qo‘shinlari shaharni deyarli butunlay vayron qilgan, biroq keyinroq yaqin atrofda yangi shahar tiklangan.

Bugungi kunda Termiz nafaqat tarixiy, balki chegara shahri sifatida ham strategik ahamiyatga ega bo‘lib, uning atrofidagi arxeologik yodgorliklar O‘zbekistonning eng noyob merosi hisoblanadi.
`,
        sections: [
            {
                title: "Fayoztepa buddist majmuasi",

                content: `
Fayoztepa — Termiz yaqinidagi qadimiy buddist monastiri bo‘lib, Kushon imperiyasi davrida O‘rta Osiyoda buddizmning markazlaridan biri bo‘lgan.

Bu yer arxeologik qazishmalar natijasida topilgan bo‘lib, noyob haykaltaroshlik va devor rasmlari bilan mashhur.

Fayoztepa Markaziy Osiyoda buddizm tarixini o‘rganishda eng muhim manbalardan biri hisoblanadi.
    `,

                details: `
Fayoztepa I–III asrlarda faoliyat yuritgan bo‘lib, u stupa, ibodatxona va rohiblar turar joyidan iborat majmuadir.

📌 Topilmalar:
- Budda haykallari va relyeflari
- Gaudxara uslubidagi devor rasmlari
- Kushon davri tangalari va yozuvlari

📌 Tarixiy ahamiyati:
- O‘rta Osiyoda buddizm tarqalishining muhim dalili
- Hindiston va Kushon madaniyati aloqalarini ko‘rsatadi
- Zamonaviy Termiz arxeologiya muzeyida topilmalar saqlanadi

Majmua hozirda qisman tiklangan bo‘lib, ochiq osmon ostidagi arxeologik yodgorlik sifatida saqlanmoqda.
    `,
                facts: [
                    "Termiz shahri yaqinida joylashgan",
                    "I–III asrlarda faoliyat yuritgan buddist monastiri",
                    "Kushon imperiyasi davriga tegishli",
                    "Stupa va ibodatxona qoldiqlaridan iborat",
                    "Budda haykallari va relyeflari topilgan",
                    "Gandxara uslubidagi san’at namunalari saqlangan",
                    "O‘rta Osiyoda buddizm tarixining muhim dalili",
                    "Arxeologik qazishmalar XX asrda olib borilgan",
                    "Topilmalar Termiz arxeologiya muzeyida saqlanadi",
                    "Hindiston-Kushon madaniy aloqalarini ko‘rsatadi",
                    "Ochiq osmon ostidagi muzey sifatida qaraladi",
                    "Markaziy Osiyodagi noyob diniy yodgorlik",
                    "Ilmiy tadqiqotlar uchun muhim manba",
                    "Surxondaryoning eng qadimiy obidalaridan biri",
                    "Sayyohlar uchun qiziqarli arxeologik maskan"
                ],
                images: [fayoz1, fayoz2, fayoz3,]
            },

            {
                title: "Qadimiy Termiz (Eski shahar)",

                content: `
Qadimiy Termiz — Amudaryo bo‘yida joylashgan, Kushon va islom davrlariga oid ulkan shahar xarobasi bo‘lib, hozirgi Termiz shahridan g‘arbroqda joylashgan.

Bu yer bir necha ming yillik tarixni o‘zida mujassam etgan bo‘lib, shahar qal’asi, masjid va hammom qoldiqlarini o‘z ichiga oladi.

Qadimiy Termiz O‘zbekistondagi eng yirik arxeologik majmualardan biri hisoblanadi.
    `,

                details: `
Shahar miloddan avvalgi IV asrdan XIII asrgacha turli davrlarda faol bo‘lgan bo‘lib, Chingizxon istilosidan so‘ng aholi yangi joyga ko‘chirilgan.

📌 Saqlangan qismlar:
- Shahar qal’asi (arki) qoldiqlari
- IX–XII asrlarga oid Jome masjidi xarobalari
- O‘rta asr hammomi qoldiqlari
- Qadimiy devor va mudofaa inshootlari

📌 Tarixiy ahamiyati:
- Buyuk Ipak yo‘lining eng muhim kechuv-shaharlaridan biri
- Islom ilm-fani markazlaridan biri bo‘lgan
- Al-Hakim at-Termiziy shu shaharda faoliyat yuritgan

Bugungi kunda hudud arxeologik qo‘riqxona maqomiga ega bo‘lib, qazishma ishlari davom etmoqda.
    `,
                facts: [
                    "Hozirgi Termiz shahridan g‘arbda joylashgan",
                    "Miloddan avvalgi IV asrdan mavjud bo‘lgan",
                    "1220-yilda Chingizxon tomonidan vayron qilingan",
                    "Shahar qal’asi qoldiqlari saqlangan",
                    "IX–XII asr Jome masjidi xarobalari mavjud",
                    "O‘rta asr hammomi qoldiqlari topilgan",
                    "Buyuk Ipak yo‘lining muhim kechuv-shahri bo‘lgan",
                    "Islom ilm-fani markazlaridan biri hisoblangan",
                    "Arxeologik qo‘riqxona maqomiga ega",
                    "Qazishma ishlari hozirgacha davom etmoqda",
                    "O‘zbekistondagi eng yirik shahar xarobalaridan biri",
                    "Amudaryo bo‘yida strategik joyda joylashgan",
                    "Kushon va islom davri qatlamlarini o‘z ichiga oladi",
                    "Tarixchilar uchun boy ilmiy manba",
                    "Surxondaryoning asosiy tarixiy diqqatga sazovor joyi"
                ],
                images: [eskisha1, eskisha2, eskisha3,]
            },

            {
                title: "Al-Hakim at-Termiziy maqbarasi",

                content: `
Al-Hakim at-Termiziy maqbarasi buyuk islom olimi va mutasavvifi Abu Abdulloh Muhammad al-Hakim at-Termiziy sharafiga qurilgan bo‘lib, mintaqaning muqaddas ziyoratgohlaridan biri hisoblanadi.

Bu maskan asrlar davomida musulmonlar uchun muhim ziyorat markazi bo‘lib kelgan.

Maqbara islom me’morchiligi va tasavvuf tarixini o‘rganishda muhim ahamiyatga ega.
    `,

                details: `
Al-Hakim at-Termiziy IX asrda yashab ijod etgan bo‘lib, u tasavvuf ta’limotining asoschilaridan biri hisoblanadi.

📌 Maqbara haqida:
- Dastlabki maqbara IX asrda qurilgan
- Keyinchalik Temuriylar davrida kengaytirilgan va bezatilgan
- Sopol va koshin bezaklari qo‘shilgan

📌 Diniy ahamiyati:
- Markaziy Osiyodagi eng muhim tasavvuf ziyoratgohlaridan biri
- Al-Hakim at-Termiziyning "Hakim ota" nomi bilan mashhur ta’limoti shu yerda shakllangan
- Musulmon olamida hurmat qozongan ilmiy meros qoldirgan

Majmua bugungi kunda ham faol ziyoratgoh bo‘lib, uning yonida yangi masjid va ma’muriy binolar qurilgan.
    `,
                facts: [
                    "Termiz shahrida, Amudaryo yaqinida joylashgan",
                    "IX asrda yashagan olim sharafiga qurilgan",
                    "Al-Hakim at-Termiziy tasavvuf asoschilaridan biri",
                    "Dastlabki maqbara IX asrga tegishli",
                    "Temuriylar davrida kengaytirilgan",
                    "Koshin va sopol bezaklar bilan boyitilgan",
                    "Markaziy Osiyoning muhim tasavvuf markazi",
                    "Musulmonlar uchun muqaddas ziyoratgoh",
                    "\"Hakim ota\" nomi bilan xalq orasida tanilgan",
                    "Yonida zamonaviy masjid qurilgan",
                    "Har yili minglab ziyoratchilar tashrif buyuradi",
                    "Islom ilmiy merosining muhim qismi",
                    "Surxondaryoning diniy-ma’naviy markazi",
                    "Tasavvuf tarixini o‘rganishda muhim manba",
                    "Termizning eng ziyorat qilinadigan maskani"
                ],
                images: [hakim1, hakim2, hakim3,]
            },

            {
                title: "Sulton Saodat majmuasi",

                content: `
Sulton Saodat majmuasi Termizning eng ulkan va go‘zal maqbaralar kompleksi bo‘lib, X–XVII asrlar davomida shakllangan.

Bu majmuada Termiz sayidlari — payg‘ambar avlodidan bo‘lgan hukmdorlar sulolasi dafn etilgan bo‘lib, u mintaqaning muhim ziyoratgohlaridan biri hisoblanadi.

Majmua o‘n nechta gumbazli maqbaralardan iborat bo‘lib, Termiz me’morchiligining rivojlanish tarixini ko‘rsatadi.
    `,

                details: `
Sulton Saodat majmuasi bir necha asr davomida qurilgan bo‘lib, u Termiz sayidlari sulolasining oilaviy qabristoniga aylangan.

📌 Majmua tarkibi:
- 15 dan ortiq gumbazli maqbaralar
- Turli davrlarga oid me’moriy uslublar
- Koshin va g‘isht bezaklari

📌 Tarixiy ahamiyati:
- Termiz sayidlari mintaqada katta diniy va siyosiy nufuzga ega bo‘lgan
- Majmua X asrdan XVII asrgacha qurilishi davom etgan
- Har bir maqbara o‘z davri me’morchiligini aks ettiradi

Majmua Termizning eng qadimiy va uzoq davr davomida shakllangan yodgorliklaridan biri sifatida alohida ilmiy ahamiyatga ega.
    `,
                facts: [
                    "Termiz shahrida joylashgan",
                    "X–XVII asrlar davomida shakllangan",
                    "Termiz sayidlari sulolasining qabristoni",
                    "15 dan ortiq gumbazli maqbaralardan iborat",
                    "Turli davr me’moriy uslublarini o‘z ichiga oladi",
                    "Koshin va pishiq g‘isht bezaklari mavjud",
                    "Payg‘ambar avlodidan bo‘lgan hukmdorlar dafn etilgan",
                    "Mintaqaning muhim diniy-siyosiy markazi bo‘lgan",
                    "Termizning eng uzoq davr qurilgan majmuasi",
                    "Me’morchilik rivojlanishini bosqichma-bosqich ko‘rsatadi",
                    "Ziyoratchilar uchun muhim maskan",
                    "Surxondaryoning yirik tarixiy yodgorligi",
                    "Ilmiy tadqiqotlar uchun boy manba",
                    "Har bir maqbara alohida me’moriy qiymatga ega",
                    "Termiz tarixini o‘rganishda kalit obida"
                ],
                images: [saodat1, saodat2, saodat3,]
            },

            {
                title: "Zurmala minorasi (buddist stupasi)",

                content: `
Zurmala minorasi — Termiz yaqinida joylashgan qadimiy buddist stupasi bo‘lib, Kushon davri me’morchiligining noyob namunasi hisoblanadi.

Bu inshoot O‘zbekistonda saqlanib qolgan yagona yirik buddist stupalaridan biri bo‘lib, mintaqada buddizmning tarqalganligidan dalolat beradi.

Zurmala arxeologiya va din tarixi ixlosmandlari uchun muhim maskan hisoblanadi.
    `,

                details: `
Zurmala stupasi I–II asrlarda, Kushon imperiyasi davrida qurilgan.

📌 Arxitektura:
- Balandligi taxminan 15 metrga yetgan
- Xom g‘ishtdan ishlangan silindrsimon tuzilma
- Asl holida stupa ustida ibodat inshooti bo‘lgan deb taxmin qilinadi

📌 Tarixiy ahamiyati:
- Kushon davrida buddizm mintaqada keng yoyilganligini tasdiqlaydi
- O‘zbekistonda saqlanib qolgan noyob buddist inshooti
- Arxeologik tadqiqotlar hozirgacha davom etmoqda

Vaqt o‘tishi bilan qurilma qisman shikastlangan bo‘lsa-da, uning ulkan xom g‘isht tuzilmasi hozirgacha saqlanib qolgan.
    `,
                facts: [
                    "Termiz shahri yaqinida joylashgan",
                    "I–II asrlarda, Kushon davrida qurilgan",
                    "O‘zbekistonda saqlangan noyob buddist stupasi",
                    "Balandligi taxminan 15 metrga yetgan",
                    "Xom g‘ishtdan ishlangan silindrsimon tuzilma",
                    "Buddizmning mintaqada tarqalganini tasdiqlaydi",
                    "Arxeologik tadqiqotlar hozir ham davom etmoqda",
                    "Kushon imperiyasi me’morchiligining namunasi",
                    "Din tarixi bo‘yicha muhim ilmiy manba",
                    "Surxondaryoning noyob arxeologik yodgorligi",
                    "Markaziy Osiyoda kamdan-kam saqlangan stupalardan biri",
                    "Qisman shikastlangan holda saqlanib qolgan",
                    "Tadqiqotchilar uchun katta qiziqish uyg‘otadi",
                    "Termiz atrofidagi buddist meros majmuasining bir qismi",
                    "Sayyohlar uchun kam tanilgan, ammo qiziqarli maskan"
                ],
                images: [zurmala1, zurmala2, zurmala3,]
            },

            {
                title: "Kampirtepa qadimiy istehkomi",

                content: `
Kampirtepa — Amudaryo bo‘yida joylashgan qadimiy istehkom va shahar xarobasi bo‘lib, yunon-baqtriya va Kushon davrlariga oid muhim arxeologik obyekt hisoblanadi.

Bu yer Aleksandr Makedonskiy davridan qolgan kechuv-qal’a bo‘lishi mumkinligi bo‘yicha ilmiy taxminlar mavjud.

Kampirtepa Termiz atrofidagi eng qadimiy arxeologik yodgorliklardan biri sifatida alohida qiziqish uyg‘otadi.
    `,

                details: `
Kampirtepa miloddan avvalgi IV–III asrlarda barpo etilgan bo‘lib, u Amudaryoning muhim kechuv nuqtasini nazorat qilgan.

📌 Topilmalar:
- Yunon-baqtriya davriga oid mudofaa devorlari
- Kushon davri turar-joy qoldiqlari
- Tangalar, keramika va harbiy anjomlar

📌 Ilmiy taxminlar:
Ba’zi tadqiqotchilar Kampirtepani Aleksandr Makedonskiy tomonidan qurdirilgan qal’alardan biri, ehtimol "Aleksandriya Oksiana" bilan bog‘liq degan farazni ilgari surishadi.

📌 Ahamiyati:
Kampirtepa yunon-baqtriya va Kushon davri harbiy-mudofaa tizimini o‘rganishda muhim manba hisoblanadi.
    `,
                facts: [
                    "Amudaryo bo‘yida, Termiz yaqinida joylashgan",
                    "Miloddan avvalgi IV–III asrlarda barpo etilgan",
                    "Yunon-baqtriya davri istehkomi bo‘lgan",
                    "Amudaryoning muhim kechuvini nazorat qilgan",
                    "Aleksandr Makedonskiy davri bilan bog‘lanadi",
                    "Kushon davri turar-joy qoldiqlari topilgan",
                    "Tangalar va harbiy anjomlar aniqlangan",
                    "Yunon-baqtriya mudofaa tizimini o‘rganish manbai",
                    "Arxeologik qazishmalar davom etmoqda",
                    "Surxondaryoning qadimiy istehkomlaridan biri",
                    "Ilmiy jamoatchilik e’tiborini tortgan obyekt",
                    "\"Aleksandriya Oksiana\" farazi bilan bog‘liq",
                    "Mintaqa harbiy tarixini o‘rganishda muhim",
                    "Kam tanilgan, ammo ilmiy qiymati yuqori maskan",
                    "Termiz atrofidagi arxeologik majmuaning bir qismi"
                ],
                images: [kampirtepa1, kampirtepa2, kampirtepa3,]
            }
        ]
    },
    ru: {
        key: "termiz",
        title: "Термез — древний город на перекрёстке цивилизаций",

        intro: `
Термез — древний город, расположенный в Сурхандарьинской области на берегу Амударьи, с историей более 2500 лет.

Это уникальный регион, где пересекались буддийская, зороастрийская и исламская культуры. В древности город был одним из важных пунктов Великого Шёлкового пути.
`,

        history: `
Термез является одним из самых древних городов Центральной Азии, а его история уходит корнями во времена Александра Македонского. Согласно некоторым историческим источникам, город был основан в греко-бактрийский период под названием «Александрия Оксиана».

Во времена Кушанской империи (I–IV века) Термез стал важным торговым и религиозным центром. В этот период здесь широко распространился буддизм, а вокруг города были построены многочисленные монастыри и храмы.

Благодаря своему расположению у удобной переправы через Амударью Термез стал одним из важнейших пунктов Великого Шёлкового пути. Здесь встречались торговцы из Индии, Китая, Ирана и стран Средиземноморья.

В IX–XII веках Термез превратился в один из центров исламской науки. Здесь жил и творил великий учёный и философ Абу Абдуллах Мухаммад аль-Хаким ат-Термези.

В 1220 году войска Чингисхана практически полностью разрушили город, однако позже рядом был восстановлен новый город.

Сегодня Термез имеет не только историческое, но и стратегическое значение как пограничный город. Археологические памятники вокруг города являются одним из самых уникальных культурных наследий Узбекистана.
`,

        sections: [
            {
                title: "Буддийский комплекс Фаязтепа",

                content: `
Фаязтепа — древний буддийский монастырский комплекс, расположенный недалеко от Термеза. Во времена Кушанской империи он был одним из важных центров распространения буддизма в Центральной Азии.

Этот памятник был обнаружен в результате археологических раскопок и известен своими уникальными скульптурами и настенными росписями.

Фаязтепа является одним из важнейших источников для изучения истории буддизма в Центральной Азии.
`,

                details: `
Фаязтепа функционировал в I–III веках и представлял собой комплекс, состоящий из ступы, храмовых помещений и жилых комнат для монахов.

📌 Археологические находки:
- Статуи Будды и рельефные изображения
- Настенные росписи в стиле Гандхара
- Монеты и надписи периода Кушанской империи

📌 Историческое значение:
- Важное свидетельство распространения буддизма в Центральной Азии
- Показывает культурные связи Индии и Кушанского государства
- Найденные артефакты хранятся в Археологическом музее Термеза

Сегодня комплекс частично восстановлен и сохраняется как уникальный археологический памятник под открытым небом.
`,

                facts: [
                    "Расположен недалеко от города Термез",
                    "Буддийский монастырь I–III веков",
                    "Относится к периоду Кушанской империи",
                    "Включает остатки ступы и храмовых сооружений",
                    "Были обнаружены статуи Будды и рельефы",
                    "Сохранились образцы искусства Гандхары",
                    "Является важным свидетельством истории буддизма в Центральной Азии",
                    "Археологические раскопки проводились в XX веке",
                    "Находки хранятся в Археологическом музее Термеза",
                    "Отражает культурные связи Индии и Кушанской империи",
                    "Рассматривается как музей под открытым небом",
                    "Один из уникальных религиозных памятников Центральной Азии",
                    "Важный объект для научных исследований",
                    "Один из древнейших памятников Сурхандарьи",
                    "Интересное археологическое место для туристов"
                ],

                images: [fayoz1, fayoz2, fayoz3,]
            },
            {
                title: "Древний Термез (Старый город)",

                content: `
Древний Термез — это огромный археологический комплекс, расположенный на берегу Амударьи, к западу от современного города Термез.

Этот исторический город включает памятники кушанского и исламского периодов, сохраняя в себе несколько тысячелетий истории.

Древний Термез считается одним из крупнейших археологических комплексов Узбекистана.
`,

                details: `
Город существовал с IV века до нашей эры до XIII века, переживая различные исторические эпохи. После нашествия Чингисхана жители были переселены на новое место, где позже сформировался современный Термез.

📌 Сохранившиеся части:
- Остатки городской крепости (арка)
- Руины соборной мечети IX–XII веков
- Остатки средневековой бани
- Древние городские стены и оборонительные сооружения

📌 Историческое значение:
- Был одним из важнейших городов-переправ Великого Шёлкового пути
- Являлся одним из центров исламской науки и культуры
- В этом городе жил и работал великий учёный Аль-Хаким ат-Термези

Сегодня территория имеет статус археологического заповедника, где продолжаются научные исследования и раскопки.
`,

                facts: [
                    "Расположен к западу от современного города Термез",
                    "Существует с IV века до нашей эры",
                    "Был разрушен войсками Чингисхана в 1220 году",
                    "Сохранились остатки древней городской крепости",
                    "Существуют руины соборной мечети IX–XII веков",
                    "Обнаружены остатки средневековой бани",
                    "Был важным городом на Великом Шёлковом пути",
                    "Являлся одним из центров исламской науки",
                    "Имеет статус археологического заповедника",
                    "Археологические раскопки продолжаются до сих пор",
                    "Один из крупнейших древних городских комплексов Узбекистана",
                    "Расположен в стратегическом месте у Амударьи",
                    "Содержит культурные слои кушанского и исламского периодов",
                    "Является ценным источником для историков",
                    "Одна из главных исторических достопримечательностей Сурхандарьи"
                ],

                images: [eskisha1, eskisha2, eskisha3,]
            },
            {
                title: "Мавзолей Аль-Хакима ат-Термези",

                content: `
Мавзолей Аль-Хакима ат-Термези был построен в честь великого исламского учёного и суфийского мыслителя Абу Абдуллаха Мухаммада аль-Хакима ат-Термези. Сегодня он является одним из самых почитаемых мест паломничества в регионе.

На протяжении многих веков этот комплекс оставался важным духовным центром для мусульман.

Мавзолей имеет большое значение для изучения исламской архитектуры и истории суфизма.
`,

                details: `
Аль-Хаким ат-Термези жил и творил в IX веке и считается одним из выдающихся представителей суфийского учения.

📌 О мавзолее:
- Первоначальный мавзолей был построен в IX веке
- Позже он был расширен и украшен в эпоху Тимуридов
- В архитектуре использованы керамические и мозаичные элементы

📌 Духовное значение:
- Один из важнейших суфийских центров Центральной Азии
- Учение Аль-Хакима ат-Термези, известного среди народа как «Хаким-ота», получило здесь широкое распространение
- Он оставил большое научное и духовное наследие, почитаемое в мусульманском мире

Сегодня комплекс продолжает функционировать как место паломничества. Рядом с мавзолеем построены новая мечеть и административные здания.
`,

                facts: [
                    "Расположен в городе Термез недалеко от Амударьи",
                    "Построен в честь учёного IX века",
                    "Аль-Хаким ат-Термези является одним из основателей суфийской традиции",
                    "Первоначальный мавзолей относится к IX веку",
                    "Был расширен в эпоху Тимуридов",
                    "Украшен керамическими и мозаичными элементами",
                    "Один из важных центров суфизма в Центральной Азии",
                    "Святое место для мусульманских паломников",
                    "Известен среди народа как «Хаким-ота»",
                    "Рядом построена современная мечеть",
                    "Ежегодно его посещают тысячи паломников",
                    "Является частью исламского научного наследия",
                    "Духовный и культурный центр Сурхандарьи",
                    "Важный источник для изучения истории суфизма",
                    "Одна из самых посещаемых достопримечательностей Термеза"
                ],

                images: [hakim1, hakim2, hakim3,]
            },
            {
                title: "Комплекс Султан Саодат",

                content: `
Комплекс Султан Саодат является одним из крупнейших и красивейших мемориальных комплексов Термеза, который формировался на протяжении X–XVII веков.

Здесь были захоронены представители термезских сайидов — династии, считавшейся потомками Пророка Мухаммада. Комплекс является одним из важнейших мест паломничества региона.

Ансамбль состоит из множества купольных мавзолеев и отражает развитие архитектуры Термеза на протяжении многих веков.
`,

                details: `
Комплекс Султан Саодат создавался в течение нескольких столетий и стал семейным некрополем династии термезских сайидов.

📌 Состав комплекса:
- Более 15 купольных мавзолеев
- Архитектурные элементы разных исторических периодов
- Декоративные украшения из кирпича и керамической плитки

📌 Историческое значение:
- Термезские сайиды обладали большим религиозным и политическим влиянием в регионе
- Строительство комплекса продолжалось с X до XVII века
- Каждый мавзолей отражает особенности архитектуры своей эпохи

Комплекс имеет большое научное значение как один из древнейших и наиболее продолжительных по времени формирования исторических памятников Термеза.
`,

                facts: [
                    "Расположен в городе Термез",
                    "Формировался с X по XVII век",
                    "Является некрополем династии термезских сайидов",
                    "Состоит более чем из 15 купольных мавзолеев",
                    "Объединяет архитектурные стили разных эпох",
                    "Украшен керамической плиткой и декоративным кирпичом",
                    "Здесь похоронены представители рода, связанного с потомками Пророка",
                    "Был важным религиозным и политическим центром региона",
                    "Один из самых длительно формировавшихся комплексов Термеза",
                    "Показывает развитие архитектуры на протяжении веков",
                    "Важное место для паломников",
                    "Один из крупнейших исторических памятников Сурхандарьи",
                    "Ценный источник для научных исследований",
                    "Каждый мавзолей имеет отдельную архитектурную ценность",
                    "Ключевой памятник для изучения истории Термеза"
                ],

                images: [saodat1, saodat2, saodat3,]
            },
            {
                title: "Башня Зурмала (буддийская ступа)",

                content: `
Башня Зурмала — древняя буддийская ступа, расположенная недалеко от Термеза, являющаяся уникальным примером архитектуры кушанского периода.

Это одна из немногих сохранившихся крупных буддийских ступ на территории Узбекистана, которая свидетельствует о широком распространении буддизма в регионе.

Зурмала представляет большой интерес для любителей археологии и истории религий.
`,

                details: `
Ступа Зурмала была построена в I–II веках во времена Кушанской империи.

📌 Архитектура:
- Высота сооружения достигала примерно 15 метров
- Цилиндрическая конструкция выполнена из сырцового кирпича
- Предполагается, что первоначально на вершине ступы находилось культовое сооружение

📌 Историческое значение:
- Подтверждает широкое распространение буддизма в регионе во времена Кушанской империи
- Является редким сохранившимся буддийским сооружением в Узбекистане
- Археологические исследования памятника продолжаются до сих пор

Несмотря на частичные разрушения со временем, массивная конструкция из сырцового кирпича сохранилась и сегодня является важным историческим памятником.
`,

                facts: [
                    "Расположена недалеко от города Термез",
                    "Построена в I–II веках в период Кушанской империи",
                    "Одна из редких сохранившихся буддийских ступ Узбекистана",
                    "Высота сооружения составляет около 15 метров",
                    "Имеет цилиндрическую форму из сырцового кирпича",
                    "Подтверждает распространение буддизма в регионе",
                    "Археологические исследования продолжаются и сегодня",
                    "Является примером архитектуры Кушанского периода",
                    "Важный научный источник по истории религий",
                    "Уникальный археологический памятник Сурхандарьи",
                    "Одна из немногих сохранившихся ступ Центральной Азии",
                    "Сохранилась несмотря на частичные разрушения",
                    "Представляет большой интерес для исследователей",
                    "Часть буддийского наследия древнего Термеза",
                    "Интересное, но малоизвестное место для туристов"
                ],

                images: [zurmala1, zurmala2, zurmala3,]
            },
            {
                title: "Древняя крепость Кампиртепа",

                content: `
Кампиртепа — древняя крепость и руины города, расположенные на берегу Амударьи. Этот археологический объект относится к греко-бактрийскому и кушанскому периодам и имеет большое историческое значение.

Существует научная гипотеза, что это место могло быть одной из переправочных крепостей эпохи Александра Македонского.

Кампиртепа считается одним из самых древних археологических памятников в окрестностях Термеза и представляет большой интерес для исследователей.
`,

                details: `
Кампиртепа была построена в IV–III веках до нашей эры и контролировала важный участок переправы через Амударью.

📌 Археологические находки:
- Оборонительные стены греко-бактрийского периода
- Остатки жилых построек кушанского времени
- Монеты, керамика и военные предметы

📌 Научные гипотезы:
Некоторые исследователи предполагают, что Кампиртепа могла быть одной из крепостей, построенных во времена Александра Македонского, и связывают её с возможной «Александрией Оксианой».

📌 Значение:
Кампиртепа является важным источником для изучения военной архитектуры и оборонительной системы греко-бактрийского и кушанского периодов.
`,

                facts: [
                    "Расположена на берегу Амударьи недалеко от Термеза",
                    "Построена в IV–III веках до нашей эры",
                    "Являлась крепостью греко-бактрийского периода",
                    "Контролировала важную переправу через Амударью",
                    "Связана с эпохой Александра Македонского",
                    "Обнаружены остатки жилых построек кушанского периода",
                    "Найдены монеты, керамика и военные предметы",
                    "Важный источник для изучения греко-бактрийской оборонительной системы",
                    "Археологические раскопки продолжаются",
                    "Один из древнейших фортификационных памятников Сурхандарьи",
                    "Привлекает внимание научного сообщества",
                    "Связана с гипотезой об «Александрии Оксиане»",
                    "Имеет большое значение для изучения военной истории региона",
                    "Малоизвестное, но ценное археологическое место",
                    "Часть древнего археологического наследия Термеза"
                ],

                images: [kampirtepa1, kampirtepa2, kampirtepa3,]
            },
        ]
    },

    en: {
        key: "termiz",
        title: "Termez — an ancient city where civilizations meet",

        intro: `
Termez is an ancient city located on the banks of the Amu Darya River in Surkhandarya region, with more than 2,500 years of history.
It is a unique place where Buddhist, Zoroastrian, and Islamic cultures met, and it was an important stop on the Great Silk Road.
`,

        history: `
Termez is one of the oldest cities in Central Asia, with a history dating back to the era of Alexander the Great. According to some historical sources, the city was founded during the Greco-Bactrian period and was known as "Alexandria Oxiana".

During the Kushan Empire (1st–4th centuries), Termez became an important commercial and religious center. Buddhism spread widely in the region, and many monasteries and temples were built around the city.

Due to its strategic location on the Amu Darya crossing, Termez became one of the most important cities on the Great Silk Road. Merchants from India, China, Persia, and Mediterranean countries met here.

During the 9th–12th centuries, Termez became a major center of Islamic science and culture. The great scholar and philosopher Abu Abdullah Muhammad al-Hakim at-Termizi lived and worked here.

In 1220, the armies of Genghis Khan almost completely destroyed the city, but later a new settlement was rebuilt nearby.

Today, Termez is not only a historical city but also an important strategic border city. The archaeological monuments surrounding it represent some of the most unique cultural heritage sites of Uzbekistan.
`,
        sections: [
            {
                title: "Fayaztepa Buddhist Complex",

                content: `
Fayaztepa is an ancient Buddhist monastery located near Termez and was one of the important centers of Buddhism in Central Asia during the Kushan Empire.

The site was discovered through archaeological excavations and is famous for its unique sculptures and ancient wall paintings.

Fayaztepa is considered one of the most important sources for studying the history of Buddhism in Central Asia.
`,

                details: `
Fayaztepa was active during the 1st–3rd centuries and consisted of a stupa, temples, and residential areas for monks.

📌 Archaeological discoveries:
- Buddhist statues and reliefs
- Wall paintings created in the Gandhara artistic style
- Kushan-period coins and ancient inscriptions

📌 Historical significance:
- An important evidence of the spread of Buddhism in Central Asia
- Shows cultural connections between India and the Kushan Empire
- Many discovered artifacts are preserved in the Termez Archaeological Museum

Today, the complex has been partially restored and is preserved as an open-air archaeological monument.
`,

                facts: [
                    "Located near the city of Termez",
                    "A Buddhist monastery active during the 1st–3rd centuries",
                    "Belongs to the period of the Kushan Empire",
                    "Includes remains of a stupa and Buddhist temples",
                    "Buddhist statues and reliefs were discovered here",
                    "Contains examples of Gandhara artistic style",
                    "Important evidence of Buddhism in Central Asia",
                    "Archaeological excavations were carried out in the 20th century",
                    "Artifacts are preserved in the Termez Archaeological Museum",
                    "Shows cultural connections between India and the Kushan Empire",
                    "Considered an open-air archaeological museum",
                    "One of the unique religious monuments of Central Asia",
                    "Important source for scientific research",
                    "One of the oldest historical sites in Surkhandarya",
                    "An interesting archaeological destination for tourists"
                ],

                images: [fayoz1, fayoz2, fayoz3,]
            },
            {
                title: "Ancient Termez (Old City)",

                content: `
Ancient Termez is a large archaeological complex located on the banks of the Amu Darya River, west of the modern city of Termez.

This historical site preserves several thousand years of history, including remains of city fortifications, mosques, and medieval buildings.

Ancient Termez is considered one of the largest archaeological complexes in Uzbekistan.
`,

                details: `
The city existed from the 4th century BC until the 13th century and experienced different historical periods. After the invasion of Genghis Khan, the population moved to a new location where modern Termez later developed.

📌 Preserved remains:
- Ruins of the city fortress (ark)
- Remains of a Jame Mosque from the 9th–12th centuries
- Remains of medieval baths
- Ancient city walls and defensive structures

📌 Historical significance:
- One of the most important crossing cities on the Great Silk Road
- One of the major centers of Islamic science and culture
- The famous scholar Al-Hakim at-Termizi lived and worked here

Today, the area has the status of an archaeological reserve, where excavations and scientific studies are still being carried out.
`,

                facts: [
                    "Located west of modern Termez",
                    "Has existed since the 4th century BC",
                    "Destroyed by the army of Genghis Khan in 1220",
                    "Remains of the ancient city fortress have been preserved",
                    "Contains ruins of a 9th–12th century Jame Mosque",
                    "Remains of medieval baths were discovered here",
                    "Was an important city on the Great Silk Road",
                    "Was one of the centers of Islamic science",
                    "Has the status of an archaeological reserve",
                    "Archaeological excavations are still continuing",
                    "One of the largest ancient city complexes in Uzbekistan",
                    "Located in a strategic position near the Amu Darya River",
                    "Contains cultural layers from the Kushan and Islamic periods",
                    "A valuable source for historians and archaeologists",
                    "One of the main historical attractions of Surkhandarya"
                ],

                images: [eskisha1, eskisha2, eskisha3,]
            },
            {
                title: "Al-Hakim at-Termizi Mausoleum",

                content: `
The Al-Hakim at-Termizi Mausoleum was built in honor of the great Islamic scholar and mystic Abu Abdullah Muhammad al-Hakim at-Termizi and is one of the most important pilgrimage sites in the region.

For centuries, this place has been an important spiritual center for Muslims.

The mausoleum plays an important role in studying Islamic architecture and the history of Sufism.
`,

                details: `
Al-Hakim at-Termizi lived and worked in the 9th century and is considered one of the important figures in the development of Sufi teachings.

📌 About the mausoleum:
- The original mausoleum was built in the 9th century
- It was later expanded and decorated during the Timurid period
- Ceramic and glazed tile decorations were added

📌 Religious significance:
- One of the most important Sufi pilgrimage sites in Central Asia
- The teachings of Al-Hakim at-Termizi, known among people as "Hakim Ota", became famous in this region
- He left a valuable scientific and spiritual heritage respected throughout the Muslim world

Today, the complex remains an active pilgrimage site, with a modern mosque and administrative buildings located nearby.
`,

                facts: [
                    "Located near the city of Termez, close to the Amu Darya River",
                    "Built in honor of the 9th-century scholar Al-Hakim at-Termizi",
                    "Al-Hakim at-Termizi was one of the important figures of Sufism",
                    "The original mausoleum dates back to the 9th century",
                    "Expanded and renovated during the Timurid period",
                    "Decorated with ceramic and glazed tile elements",
                    "One of the important Sufi centers of Central Asia",
                    "A sacred pilgrimage site for Muslims",
                    "Known among local people as Hakim Ota",
                    "A modern mosque was built near the complex",
                    "Thousands of visitors come here every year",
                    "An important part of Islamic scientific heritage",
                    "A spiritual and cultural center of Surkhandarya",
                    "Important source for studying the history of Sufism",
                    "One of the most visited historical sites of Termez"
                ],

                images: [hakim1, hakim2, hakim3,]
            },
            {
                title: "Sultan Saodat Complex",

                content: `
The Sultan Saodat Complex is one of the largest and most beautiful mausoleum complexes in Termez, formed over many centuries from the 10th to the 17th centuries.

The complex contains the burial places of the Termez Sayyids — a noble dynasty believed to be descendants of the Prophet Muhammad.

With its numerous domed mausoleums, the complex reflects the long history of architectural development in Termez.
`,

                details: `
The Sultan Saodat Complex was built over several centuries and became the family necropolis of the Termez Sayyid dynasty.

📌 Structure of the complex:
- More than 15 domed mausoleums
- Architectural styles from different historical periods
- Decorative brickwork and glazed tile ornaments

📌 Historical significance:
- The Termez Sayyids had great religious and political influence in the region
- The construction of the complex continued from the 10th to the 17th centuries
- Each mausoleum reflects the architectural traditions of its own period

The complex is one of the oldest and longest-developed historical monuments of Termez and has great scientific and cultural importance.
`,

                facts: [
                    "Located in the city of Termez",
                    "Developed between the 10th and 17th centuries",
                    "Served as the burial place of the Termez Sayyid dynasty",
                    "Consists of more than 15 domed mausoleums",
                    "Includes architectural styles from different periods",
                    "Decorated with glazed tiles and baked brick patterns",
                    "Members of a dynasty connected to the Prophet's descendants are buried here",
                    "Was an important religious and political center of the region",
                    "Represents the architectural development of several centuries",
                    "Each mausoleum has its own historical value",
                    "A significant pilgrimage site",
                    "One of the largest historical monuments of Surkhandarya",
                    "An important source for scientific research",
                    "Shows different stages of Termez architectural history",
                    "A key monument for studying the history of Termez"
                ],

                images: [saodat1, saodat2, saodat3,]
            },
            {
                title: "Zurmala Tower (Buddhist Stupa)",

                content: `
Zurmala Tower is an ancient Buddhist stupa located near Termez and is considered a unique example of Kushan-period architecture.

It is one of the few large Buddhist monuments preserved in Uzbekistan and serves as evidence of the spread of Buddhism in the region.

Zurmala is an important historical site for those interested in archaeology and the history of religions.
`,

                details: `
The Zurmala Stupa was built in the 1st–2nd centuries during the Kushan Empire.

📌 Architecture:
- Reached approximately 15 meters in height
- Built from raw brick with a cylindrical structure
- Originally believed to have contained a religious structure at the top

📌 Historical significance:
- Confirms the widespread influence of Buddhism during the Kushan period
- One of the rare preserved Buddhist monuments in Uzbekistan
- Continues to be studied by archaeologists

Although partially damaged over time, the massive raw-brick structure of Zurmala has survived and remains an important part of the Buddhist heritage of Termez.
`,

                facts: [
                    "Located near the city of Termez",
                    "Built in the 1st–2nd centuries during the Kushan Empire",
                    "One of the rare preserved Buddhist stupas in Uzbekistan",
                    "Reached approximately 15 meters in height",
                    "Built from raw brick in a cylindrical shape",
                    "Provides evidence of the spread of Buddhism in Central Asia",
                    "Archaeological research continues today",
                    "An example of Kushan-period architecture",
                    "An important scientific source for religious history",
                    "A unique archaeological monument of Surkhandarya",
                    "One of the few surviving stupas in Central Asia",
                    "Preserved despite partial damage over time",
                    "Attracts interest from researchers and historians",
                    "Part of the Buddhist heritage complex around Termez",
                    "A less-known but fascinating destination for tourists"
                ],

                images: [zurmala1, zurmala2, zurmala3,]
            },
            {
                title: "Kampirtepa Ancient Fortress",

                content: `
Kampirtepa is an ancient fortress and city settlement located on the banks of the Amu Darya River. It is an important archaeological site belonging to the Greco-Bactrian and Kushan periods.

There is a scientific hypothesis that this place may have been a river crossing fortress from the time of Alexander the Great.

Kampirtepa is considered one of the oldest archaeological monuments around Termez and attracts great interest from researchers.
`,

                details: `
Kampirtepa was built in the 4th–3rd centuries BC and controlled an important crossing point of the Amu Darya River.

📌 Archaeological discoveries:
- Defensive walls from the Greco-Bactrian period
- Residential remains from the Kushan period
- Coins, ceramics, and military objects

📌 Scientific theories:
Some researchers suggest that Kampirtepa may have been one of the fortresses built during the era of Alexander the Great and possibly connected with the ancient city known as "Alexandria Oxiana".

📌 Historical importance:
Kampirtepa is an important source for studying the military architecture and defensive systems of the Greco-Bactrian and Kushan periods.
`,

                facts: [
                    "Located on the banks of the Amu Darya near Termez",
                    "Built in the 4th–3rd centuries BC",
                    "Was a fortress of the Greco-Bactrian period",
                    "Controlled an important crossing point of the Amu Darya River",
                    "Connected with the era of Alexander the Great",
                    "Remains of Kushan-period settlements were discovered",
                    "Coins, ceramics, and military objects were found",
                    "Important source for studying Greco-Bactrian defense systems",
                    "Archaeological excavations are still ongoing",
                    "One of the oldest fortresses in Surkhandarya",
                    "Attracts attention from the scientific community",
                    "Connected with the hypothesis of Alexandria Oxiana",
                    "Important for studying the military history of the region",
                    "A little-known but highly valuable archaeological site",
                    "Part of the ancient archaeological heritage of Termez"
                ],

                images: [kampirtepa1, kampirtepa2, kampirtepa3,]
            },
        ]
    },

    fr: {
        key: "termiz",
        title: "Termez — une ancienne ville au carrefour des civilisations",

        intro: `
Termez est une ancienne ville située dans la région de Sourkhan-Daria, sur les rives de l’Amou-Daria, avec plus de 2500 ans d’histoire.

C’est un lieu unique où se sont rencontrées les cultures bouddhiste, zoroastrienne et islamique. Dans l’Antiquité, la ville était une étape importante de la Grande Route de la Soie.
`,

        history: `
Termez est l’une des plus anciennes villes d’Asie centrale, dont l’histoire remonte à l’époque d’Alexandre le Grand. Selon certaines sources historiques, la ville aurait été fondée pendant la période gréco-bactrienne sous le nom d’« Alexandria Oxiana ».

Sous l’Empire kouchan (Iᵉʳ–IVᵉ siècles), Termez est devenue un important centre commercial et religieux. Le bouddhisme s’est largement développé dans la région et de nombreux monastères et temples ont été construits autour de la ville.

Grâce à sa position stratégique près d’un passage de l’Amou-Daria, Termez est devenue l’une des étapes majeures de la Grande Route de la Soie. Des marchands venus d’Inde, de Chine, de Perse et des pays méditerranéens s’y rencontraient.

Aux IXᵉ–XIIᵉ siècles, Termez est devenue un centre important des sciences et de la culture islamiques. Le grand savant et philosophe Abu Abdullah Muhammad al-Hakim at-Termizi y a vécu et travaillé.

En 1220, les armées de Gengis Khan ont presque entièrement détruit la ville, mais une nouvelle ville a ensuite été reconstruite à proximité.

Aujourd’hui, Termez possède une grande importance historique et stratégique en tant que ville frontalière. Les monuments archéologiques qui l’entourent représentent l’un des patrimoines culturels les plus précieux d’Ouzbékistan.
`,

        sections: [
            {
                title: "Complexe bouddhiste de Fayaztepa",

                content: `
Fayaztepa est un ancien monastère bouddhiste situé près de Termez. Il était l’un des centres importants du bouddhisme en Asie centrale pendant la période de l’Empire kouchan.

Ce site a été découvert grâce aux fouilles archéologiques et est célèbre pour ses sculptures uniques et ses anciennes peintures murales.

Fayaztepa est considéré comme l’une des sources les plus importantes pour l’étude de l’histoire du bouddhisme en Asie centrale.
`,

                details: `
Fayaztepa a fonctionné entre le Iᵉʳ et le IIIᵉ siècle. Le complexe comprenait un stupa, des temples et des espaces d’habitation pour les moines.

📌 Découvertes archéologiques :
- Statues et reliefs bouddhistes
- Peintures murales de style Gandhara
- Monnaies et inscriptions datant de l’époque kouchane

📌 Importance historique :
- Témoigne de la diffusion du bouddhisme en Asie centrale
- Montre les liens culturels entre l’Inde et l’Empire kouchan
- Les objets découverts sont conservés au musée archéologique de Termez

Aujourd’hui, le complexe est partiellement restauré et conservé comme un monument archéologique à ciel ouvert.
`,

                facts: [
                    "Situé près de la ville de Termez",
                    "Ancien monastère bouddhiste actif entre le Ier et le IIIe siècle",
                    "Appartient à la période de l’Empire kouchan",
                    "Comprend les vestiges d’un stupa et de temples bouddhistes",
                    "Des statues et des reliefs de Bouddha y ont été découverts",
                    "Présente des exemples d’art de style Gandhara",
                    "Preuve importante de la présence du bouddhisme en Asie centrale",
                    "Les fouilles archéologiques ont été menées au XXe siècle",
                    "Les objets sont conservés au musée archéologique de Termez",
                    "Montre les échanges culturels entre l’Inde et les Kouchans",
                    "Considéré comme un musée archéologique à ciel ouvert",
                    "L’un des monuments religieux uniques d’Asie centrale",
                    "Une source importante pour les recherches scientifiques",
                    "L’un des sites historiques les plus anciens de Sourkhan-Daria",
                    "Une destination archéologique intéressante pour les touristes"
                ],

                images: [fayoz1, fayoz2, fayoz3,]
            },
            {
                title: "Termez ancien (Vieille ville)",

                content: `
Termez ancien est un vaste complexe archéologique situé sur les rives de l’Amou-Daria, à l’ouest de la ville moderne de Termez.

Ce site conserve plusieurs milliers d’années d’histoire, avec les vestiges d’une ancienne forteresse, de mosquées et de bâtiments médiévaux.

Termez ancien est considéré comme l’un des plus grands ensembles archéologiques d’Ouzbékistan.
`,

                details: `
La ville a existé du IVᵉ siècle avant notre ère jusqu’au XIIIᵉ siècle et a connu différentes périodes historiques. Après l’invasion de Gengis Khan, la population a quitté l’ancienne ville et une nouvelle implantation s’est développée à proximité.

📌 Vestiges conservés :
- Ruines de la forteresse de la ville (ark)
- Restes d’une mosquée du vendredi datant des IXᵉ–XIIᵉ siècles
- Vestiges de bains médiévaux
- Anciennes murailles et structures défensives

📌 Importance historique :
- L’une des villes de passage les plus importantes de la Grande Route de la Soie
- Un grand centre des sciences et de la culture islamiques
- Le célèbre savant Al-Hakim at-Termizi y a vécu et travaillé

Aujourd’hui, le site possède le statut de réserve archéologique, où les fouilles et les recherches scientifiques se poursuivent encore.
`,

                facts: [
                    "Situé à l’ouest de la ville moderne de Termez",
                    "Existe depuis le IVᵉ siècle avant notre ère",
                    "Détruit par les armées de Gengis Khan en 1220",
                    "Les vestiges de l’ancienne forteresse sont conservés",
                    "Comprend les ruines d’une mosquée du vendredi des IXᵉ–XIIᵉ siècles",
                    "Des vestiges de bains médiévaux ont été découverts",
                    "Était une étape importante de la Grande Route de la Soie",
                    "Était l’un des centres des sciences islamiques",
                    "Possède le statut de réserve archéologique",
                    "Les fouilles archéologiques continuent encore aujourd’hui",
                    "L’un des plus grands complexes urbains anciens d’Ouzbékistan",
                    "Situé dans une position stratégique près de l’Amou-Daria",
                    "Contient des couches historiques des périodes kouchane et islamique",
                    "Une source précieuse pour les historiens et les archéologues",
                    "L’un des principaux sites historiques de la région de Sourkhan-Daria"
                ],

                images: [eskisha1, eskisha2, eskisha3,]
            },
            {
                title: "Mausolée d’Al-Hakim at-Termizi",

                content: `
Le mausolée d’Al-Hakim at-Termizi a été construit en l’honneur du grand savant islamique et mystique Abu Abdullah Muhammad al-Hakim at-Termizi. Il est considéré comme l’un des lieux de pèlerinage les plus importants de la région.

Pendant des siècles, ce lieu a été un centre spirituel majeur pour les musulmans.

Le mausolée possède une grande importance pour l’étude de l’architecture islamique et de l’histoire du soufisme.
`,

                details: `
Al-Hakim at-Termizi a vécu et travaillé au IXᵉ siècle. Il est considéré comme l’une des grandes figures ayant contribué au développement de la pensée soufie.

📌 À propos du mausolée :
- Le premier mausolée a été construit au IXᵉ siècle
- Il a ensuite été agrandi et décoré pendant l’époque timouride
- Des décorations en céramique et en carreaux émaillés ont été ajoutées

📌 Importance religieuse :
- L’un des plus importants lieux de pèlerinage soufi d’Asie centrale
- Les enseignements d’Al-Hakim at-Termizi, connu sous le nom de « Hakim Ota », sont devenus célèbres dans la région
- Il a laissé un héritage scientifique et spirituel respecté dans le monde musulman

Aujourd’hui, le complexe reste un lieu de pèlerinage actif. Une mosquée moderne et des bâtiments administratifs se trouvent également à proximité.
`,

                facts: [
                    "Situé près de Termez, à proximité de l’Amou-Daria",
                    "Construit en hommage au savant du IXᵉ siècle Al-Hakim at-Termizi",
                    "Al-Hakim at-Termizi est l’une des grandes figures du soufisme",
                    "Le premier mausolée date du IXᵉ siècle",
                    "A été agrandi pendant la période timouride",
                    "Décoré avec des éléments en céramique et des carreaux émaillés",
                    "L’un des centres soufis importants d’Asie centrale",
                    "Un lieu sacré de pèlerinage pour les musulmans",
                    "Connu parmi la population locale sous le nom de « Hakim Ota »",
                    "Une mosquée moderne a été construite à proximité",
                    "Des milliers de visiteurs viennent chaque année",
                    "Une partie importante du patrimoine scientifique islamique",
                    "Un centre spirituel et culturel de la région de Sourkhan-Daria",
                    "Une source importante pour l’étude du soufisme",
                    "L’un des sites les plus visités de Termez"
                ],

                images: [hakim1, hakim2, hakim3,]
            },
            {
                title: "Complexe Sultan Saodat",

                content: `
Le complexe Sultan Saodat est l’un des plus grands et des plus beaux ensembles de mausolées de Termez. Il s’est formé progressivement entre le Xe et le XVIIe siècle.

Ce complexe abrite les sépultures des Sayyids de Termez, une dynastie noble considérée comme descendante du prophète Muhammad.

Avec ses nombreux mausolées à coupoles, le complexe représente l’évolution de l’architecture de Termez à travers plusieurs siècles.
`,

                details: `
Le complexe Sultan Saodat a été construit pendant plusieurs siècles et est devenu la nécropole familiale de la dynastie des Sayyids de Termez.

📌 Composition du complexe :
- Plus de 15 mausolées à coupoles
- Différents styles architecturaux correspondant à plusieurs époques
- Décorations en briques travaillées et en carreaux émaillés

📌 Importance historique :
- Les Sayyids de Termez possédaient une grande influence religieuse et politique dans la région
- La construction du complexe s’est poursuivie du Xe au XVIIe siècle
- Chaque mausolée reflète les traditions architecturales de son époque

Le complexe Sultan Saodat est l’un des monuments historiques les plus anciens de Termez et représente une grande valeur culturelle et scientifique.
`,

                facts: [
                    "Situé dans la ville de Termez",
                    "Formé entre le Xe et le XVIIe siècle",
                    "Ancienne nécropole de la dynastie des Sayyids de Termez",
                    "Comprend plus de 15 mausolées à coupoles",
                    "Présente différents styles architecturaux historiques",
                    "Décoré avec des briques travaillées et des carreaux émaillés",
                    "Des descendants de la famille du prophète Muhammad y sont enterrés",
                    "Était un important centre religieux et politique de la région",
                    "Montre l’évolution de l’architecture sur plusieurs siècles",
                    "Chaque mausolée possède une valeur historique particulière",
                    "Un lieu important de pèlerinage",
                    "L’un des plus grands monuments historiques de Sourkhan-Daria",
                    "Une source importante pour les recherches scientifiques",
                    "Permet d’étudier l’histoire architecturale de Termez",
                    "Un monument essentiel du patrimoine historique de Termez"
                ],

                images: [saodat1, saodat2, saodat3,]
            },
            {
                title: "Tour de Zurmala (Stupa bouddhiste)",

                content: `
La tour de Zurmala est un ancien stupa bouddhiste situé près de Termez. Elle représente un exemple unique de l’architecture de l’époque kouchane.

C’est l’un des rares grands monuments bouddhistes conservés en Ouzbékistan et un témoignage important de la diffusion du bouddhisme dans la région.

Zurmala est un site historique majeur pour les passionnés d’archéologie et d’histoire des religions.
`,

                details: `
Le stupa de Zurmala a été construit aux Ier–IIe siècles pendant l’Empire kouchan.

📌 Architecture :
- Sa hauteur atteignait environ 15 mètres
- Construction cylindrique réalisée en briques crues
- Il est supposé qu’un élément religieux se trouvait autrefois au sommet du stupa

📌 Importance historique :
- Témoigne de l’influence du bouddhisme durant la période kouchane
- L’un des rares monuments bouddhistes conservés en Ouzbékistan
- Fait encore aujourd’hui l’objet d’études archéologiques

Malgré les dommages causés par le temps, l’imposante structure en briques crues de Zurmala est toujours conservée et représente une partie importante du patrimoine bouddhiste de Termez.
`,

                facts: [
                    "Située près de la ville de Termez",
                    "Construite aux Ier–IIe siècles pendant l’Empire kouchan",
                    "L’un des rares stupas bouddhistes conservés en Ouzbékistan",
                    "Sa hauteur atteignait environ 15 mètres",
                    "Construite en briques crues avec une forme cylindrique",
                    "Témoigne de la diffusion du bouddhisme en Asie centrale",
                    "Les recherches archéologiques se poursuivent encore aujourd’hui",
                    "Un exemple remarquable de l’architecture kouchane",
                    "Une source importante pour l’histoire religieuse",
                    "Un monument archéologique unique de Sourkhan-Daria",
                    "L’un des rares stupas anciens conservés en Asie centrale",
                    "Partiellement endommagée mais toujours visible aujourd’hui",
                    "Attire l’intérêt des chercheurs et des historiens",
                    "Fait partie du patrimoine bouddhiste autour de Termez",
                    "Une destination peu connue mais fascinante pour les visiteurs"
                ],

                images: [zurmala1, zurmala2, zurmala3,]
            },
            {
                title: "Ancienne forteresse de Kampirtepa",

                content: `
Kampirtepa est une ancienne forteresse et une ville antique située sur les rives de l’Amou-Daria. Elle constitue un important site archéologique datant des périodes gréco-bactrienne et kouchane.

Selon certaines hypothèses scientifiques, cet endroit pourrait avoir été une forteresse de contrôle d’un passage du fleuve datant de l’époque d’Alexandre le Grand.

Kampirtepa est considéré comme l’un des monuments archéologiques les plus anciens autour de Termez et attire un grand intérêt scientifique.
`,

                details: `
Kampirtepa a été construit aux IVe–IIIe siècles avant notre ère et contrôlait un passage stratégique de l’Amou-Daria.

📌 Découvertes archéologiques :
- Murailles défensives de l’époque gréco-bactrienne
- Vestiges d’habitations datant de la période kouchane
- Monnaies, céramiques et objets militaires

📌 Hypothèses scientifiques :
Certains chercheurs pensent que Kampirtepa pourrait être l’une des forteresses liées à Alexandre le Grand et peut-être associée à l’ancienne cité appelée « Alexandria Oxiana ».

📌 Importance historique :
Kampirtepa est une source importante pour l’étude de l’architecture militaire et des systèmes défensifs des périodes gréco-bactrienne et kouchane.
`,

                facts: [
                    "Située sur les rives de l’Amou-Daria près de Termez",
                    "Construite aux IVe–IIIe siècles avant notre ère",
                    "Ancienne forteresse de la période gréco-bactrienne",
                    "Contrôlait un passage important de l’Amou-Daria",
                    "Associée à l’époque d’Alexandre le Grand",
                    "Des vestiges d’habitations kouchanes ont été découverts",
                    "Des monnaies, céramiques et objets militaires ont été trouvés",
                    "Une source importante pour l’étude des systèmes défensifs anciens",
                    "Les fouilles archéologiques se poursuivent encore",
                    "L’une des plus anciennes forteresses de Sourkhan-Daria",
                    "Un site qui attire l’attention des chercheurs",
                    "Liée à l’hypothèse d’« Alexandria Oxiana »",
                    "Importante pour l’étude de l’histoire militaire de la région",
                    "Un lieu peu connu mais d’une grande valeur historique",
                    "Une partie du patrimoine archéologique ancien de Termez"
                ],

                images: [kampirtepa1, kampirtepa2, kampirtepa3,]
            }
        ]
    }
};

export default termiz;